export interface Herkunft {
  quelle?: string
  medium?: string
  kampagne?: string
  inhalt?: string
  seite: string
}

export interface Anmeldung {
  vorname: string
  nachname: string
  email: string
  organisation?: string
  branche?: string
  funktion?: string
  einwilligung: true
  herkunft: Herkunft
}

export type SubmitErgebnis = { ok: true } | { ok: false; meldung: string }

/** Online-Anmeldung: server.py legt Kontakt, Firma und Event-Registrierung in Dynamics an. */
const ENDPUNKT = '/api/konferenz/anmeldung'

export function leseHerkunft(suche: string, seite: string): Herkunft {
  const p = new URLSearchParams(suche)
  const wert = (k: string) => p.get(k)?.trim() || undefined
  return {
    quelle: wert('utm_source'),
    medium: wert('utm_medium'),
    kampagne: wert('utm_campaign'),
    inhalt: wert('utm_content'),
    seite,
  }
}

/** Schickt eine Anmeldung an einen Endpunkt des Servers. Wirft nie - Fehler kommen als Ergebnis zurueck.
 *  `meldung404` ersetzt die Standardmeldung, wenn der Server mit 404 antwortet (z. B. ungueltiger Einladungslink). */
export async function sende(endpunkt: string, koerper: object, fetchImpl: typeof fetch = fetch, meldung404?: string): Promise<SubmitErgebnis> {
  try {
    const antwort = await fetchImpl(endpunkt, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(koerper),
    })
    if (antwort.ok) return { ok: true }
    if (antwort.status === 404 && meldung404) return { ok: false, meldung: meldung404 }
  } catch {
    return { ok: false, meldung: 'Es besteht derzeit keine Verbindung. Bitte versuchen Sie es erneut.' }
  }
  return { ok: false, meldung: 'Ihre Anmeldung konnte nicht übermittelt werden. Bitte versuchen Sie es später erneut.' }
}

/** Anmeldung zur Online-Teilnahme (Hauptseite). */
export function sendeAnmeldung(anmeldung: Anmeldung, fetchImpl: typeof fetch = fetch): Promise<SubmitErgebnis> {
  return sende(ENDPUNKT, anmeldung, fetchImpl)
}
